module.exports = __webpack_public_path__ + "static/about-6304721a09ccaf82d1f1399feb2ff256.png";